import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SettingsService, LanguageDefinition } from '../../services/settings-service/settings.service';

@Component({
	selector: 'app-generation-language-dropdown',
	standalone: true,
	imports: [CommonModule, NgbDropdownModule],
	templateUrl: './generation-language-dropdown.component.html',
	styleUrls: ['./generation-language-dropdown.component.scss'],
})
export class GenerationLanguageDropdownComponent {
	constructor(public settingsService: SettingsService) {}

	// Get all available languages from settings service
	get availableLanguages(): LanguageDefinition[] {
		return this.settingsService.AvailableLanguages;
	}

	// Get current selected language display name
	get currentLanguage(): string {
		return this.settingsService.GenerationLanguage;
	}

	// Set the selected language
	selectLanguage(language: LanguageDefinition): void {
		this.settingsService.GenerationLanguage = language.displayName;
	}

	// Check if a language is currently selected
	isLanguageSelected(language: LanguageDefinition): boolean {
		return this.settingsService.GenerationLanguage === language.displayName;
	}
}